/* ============================================================
   Find Your Pairing — quiz funnel (single page, 3 views)
   Home -> Quiz (5 Q) -> Results, switched client-side.
   On quiz completion, POSTs answers to {apiBase}/quiz/recommend
   and renders the AI recommendation (theme + items + frequencies),
   then checkout adds the variant + selling plan and applies the
   configured discount. Falls back gracefully if the backend is
   unavailable. Analytics via dataLayer + 'fyp:*' CustomEvents.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('find-your-pairing');
  if (!root) return;

  // ----- config from the section (data-* on root) -----
  var cfg = {
    apiBase: root.getAttribute('data-api-base') || '/apps/box-builder',
    enableAi: root.getAttribute('data-enable-ai') !== 'false',
    discountCode: root.getAttribute('data-discount-code') || '',
    discountAmount: parseFloat(root.getAttribute('data-discount-amount')) || 0,
    minLoadingMs: parseInt(root.getAttribute('data-loading-delay'), 10) || 2200,
    maxWaitMs: parseInt(root.getAttribute('data-max-wait'), 10) || 15000,
    freeGiftVariantId: (root.getAttribute('data-free-gift-variant') || '').trim(),
    countdownSeconds: parseInt(root.getAttribute('data-countdown-seconds'), 10) || (19 * 60 + 57)
  };

  // Recharge bundle provisioning (matches the customize-my-box flow). The box
  // and tray are Recharge bundles; checkout builds `selections` from the chosen
  // items and calls recharge.bundle.getBundleId before adding to the cart.
  var RECHARGE = {
    storeIdentifier: '504ac4.myshopify.com',
    boxProductId: '9737594896664',
    trayProductId: '10177967554840'
  };

  // ----- state -----
  // answers: { audience, painPoint, adventurousness, dietary, picture }
  // recommendation: backend response (Phase 5 renders from it)
  var state = { product: 'box', entryProduct: null, answers: {}, preferences: '', recommendation: null };

  // Client-side fallback (used only if the backend is unreachable, or for the
  // alt-product toggle which has no fresh recommendation). Mirrors the
  // API-verified selling plans so the pricing column stays product-correct.
  var FALLBACK = {
    box: {
      defaultOptionKey: 'M',
      freqs: [
        { label: 'Every 2 Weeks', sellingPlanId: '6835142936', intervalWeeks: 2, popular: false },
        { label: 'Every 4 Weeks', sellingPlanId: '5989826840', intervalWeeks: 4, popular: true },
        { label: 'Every 6 Weeks', sellingPlanId: '5989794072', intervalWeeks: 6, popular: false },
        { label: 'Every 8 Weeks', sellingPlanId: '5989761304', intervalWeeks: 8, popular: false }
      ],
      // The Monger's Table, both sizes — core subscription default
      options: [
        { key: 'M', label: 'Medium', itemCount: 7, basePrice: 89, items: [], variantId: '50044204056856', sku: 'AHB-MCUST-MONG', defaultSellingPlanId: '5989826840' },
        { key: 'L', label: 'Large', itemCount: 9, basePrice: 109, items: [], variantId: '50044204089624', sku: 'AHB-LCUST-MONG', defaultSellingPlanId: '5989826840' }
      ]
    },
    tray: {
      defaultOptionKey: '6',
      freqs: [
        { label: 'Every 1 Week', sellingPlanId: '6848708888', intervalWeeks: 1, popular: false },
        { label: 'Every 2 Weeks', sellingPlanId: '6693191960', intervalWeeks: 2, popular: true },
        { label: 'Every 3 Weeks', sellingPlanId: '6693224728', intervalWeeks: 3, popular: false },
        { label: 'Every 4 Weeks', sellingPlanId: '6693257496', intervalWeeks: 4, popular: false }
      ],
      options: [
        { key: '6', label: '6 Trays', itemCount: 6, basePrice: 85, items: [], variantId: '51835146043672', sku: 'AHB-MCUST-TRAY', defaultSellingPlanId: '6693191960' },
        { key: '10', label: '10 Trays', itemCount: 10, basePrice: 129, items: [], variantId: '52008615772440', sku: 'AHB-LCUST-TRAY', defaultSellingPlanId: '6693191960' }
      ]
    }
  };

  // Record an answer from a clicked option carrying data-q / data-value.
  function recordAnswer(el) {
    var q = el.getAttribute('data-q');
    var v = el.getAttribute('data-value');
    if (q && v != null) { state.answers[q] = v; track('quiz_answer', { question: q, value: v }); }
  }

  // Payload sent to the backend in Phase 3+ (recommendation call).
  function buildPayload() {
    return {
      product: state.product,
      audience: state.answers.audience || null,
      painPoint: state.answers.painPoint || null,
      adventurousness: state.answers.adventurousness || null,
      dietary: state.answers.dietary || null,
      picture: state.answers.picture || null,
      // Free-text taste preferences (box flow only) — shapes the Claude curation.
      preferences: state.preferences || null,
      // When AI is off, the backend skips Claude and returns Recharge defaults.
      aiEnabled: cfg.enableAi
    };
  }

  // ----- analytics -----
  function track(name, data) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: 'fyp_' + name }, data || {}));
      }
      document.dispatchEvent(new CustomEvent('fyp:' + name, { detail: data || {} }));
    } catch (e) { /* analytics must never break the funnel */ }
  }

  // ----- helpers -----
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function byId(id) { return root.querySelector('#' + id); }
  function setText(id, val) { var el = byId(id); if (el) el.textContent = val; }
  function showEl(id, visible) { var el = byId(id); if (el) el.style.display = visible ? 'block' : 'none'; }

  // ----- view router -----
  function showView(name) {
    $all('.fyp-view').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-fyp-view') === name);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // entryProduct ('box' | 'tray' | null): when a product-specific entry point
  // (a "Find My Trays" / "Build My Box" CTA, or a ?product= deep-link) starts the
  // quiz, we already know the product — so Q5 (the box/tray router) is skipped.
  function goToQuiz(entryProduct) {
    showView('quiz');
    $all('.fyp-quiz-card, .fyp-loading-card').forEach(function (el) { el.style.display = 'none'; });
    var first = byId('fyp-q1');
    if (first) first.style.display = 'block';
    state.entryProduct = (entryProduct === 'box' || entryProduct === 'tray') ? entryProduct : null;
    state.product = state.entryProduct || 'box';
    state.answers = {};
    state.preferences = '';
    var prefsInput = byId('fyp-prefs-input');
    if (prefsInput) prefsInput.value = '';
    track('quiz_start', { entryProduct: state.entryProduct });
  }

  // Box flow only: show the free-text preferences step, then results. Its Back
  // button target differs by entry (Q5 in the general flow, Q4 when Q5 was
  // skipped for a box-specific entry). AI off → skip straight to results.
  function routeBox(backId) {
    state.product = 'box';
    if (!cfg.enableAi) { showLoadingThenResults('box'); return; }
    var card = byId('fyp-q-prefs');
    if (!card) { showLoadingThenResults('box'); return; }
    $all('.fyp-quiz-card').forEach(function (el) { el.style.display = 'none'; });
    var back = card.querySelector('[data-fyp-back]');
    if (back && backId) back.setAttribute('data-fyp-back', backId);
    card.style.display = 'block';
    card.style.animation = 'none'; void card.offsetHeight; card.style.animation = 'fyp-fadeIn 0.3s ease';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    var input = byId('fyp-prefs-input');
    if (input) { try { input.focus(); } catch (e) {} }
  }

  // Gift catalog (Q-06): show the boxes in-page (no redirect), toggling the
  // grid + heading for the chosen gift type. Products come from the theme
  // editor product-list settings, rendered server-side.
  function showGiftCatalog(dest) {
    var isSub = dest === 'subscription';
    setText('fyp-gift-heading', isSub ? 'Choose a gift subscription' : 'Choose a gift box');
    setText('fyp-gift-sub', isSub ? 'A few months of AppyHour, delivered on repeat.' : 'A one-time gift — curated and shipped.');
    var one = byId('fyp-gift-onebox-grid'); if (one) one.style.display = isSub ? 'none' : '';
    var sub = byId('fyp-gift-subscription-grid'); if (sub) sub.style.display = isSub ? '' : 'none';
    showView('gift');
    window.scrollTo({ top: 0 });
  }

  // ----- quiz navigation -----
  function gotoCard(currentCard, nextId) {
    if (currentCard) currentCard.style.display = 'none';
    var next = byId(nextId);
    if (!next) return;
    next.style.display = 'block';
    // re-trigger fade-in animation
    next.style.animation = 'none';
    void next.offsetHeight;
    next.style.animation = 'fyp-fadeIn 0.3s ease';
  }

  // ----- loading -> results -----
  // Calls the backend recommendation endpoint and waits on the real
  // response (with a minimum visible loader time and a timeout fallback).
  function showLoadingThenResults(product) {
    state.product = product;
    var payload = buildPayload();
    if (window.console && console.debug) console.debug('[find-your-pairing] quiz answers', payload);
    track('quiz_complete', payload);

    $all('.fyp-quiz-card').forEach(function (el) { el.style.display = 'none'; });
    var loading = byId('fyp-q-loading');
    if (loading) loading.style.display = 'block';

    var started = Date.now();

    // Always call the backend (the payload carries aiEnabled). When AI is off,
    // the backend skips Claude and returns the Recharge bundle defaults.
    fetchRecommendation(payload)
      .then(function (data) {
        // New shape: { recommended, box{...}, tray{...} } — both products in one
        // call so the product toggle switches with no extra request.
        state.recommendation = data || null;
        if (data && data.recommended) state.product = data.recommended;
        var recBlock = data ? data[state.product] : null;
        track('recommendation', {
          product: data ? data.recommended : state.product,
          theme: recBlock && recBlock.theme ? recBlock.theme.code : null,
          source: recBlock ? recBlock.source : 'none'
        });
      })
      .catch(function (err) {
        // Graceful fallback: render from local state (deterministic) if the
        // backend is unavailable or slow. Results page always shows.
        state.recommendation = null;
        if (window.console && console.warn) console.warn('[find-your-pairing] recommend failed, using fallback', err);
      })
      .then(function () { finishToResults(started); });
  }

  function finishToResults(started) {
    var elapsed = Date.now() - started;
    var wait = Math.max(0, cfg.minLoadingMs - elapsed);
    window.setTimeout(function () {
      applyRecommendation();
      showView('results');
      startCountdown();
    }, wait);
  }

  function fetchRecommendation(payload) {
    var url = cfg.apiBase + '/quiz/recommend';
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, cfg.maxWaitMs) : null;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store',
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) window.clearTimeout(timer);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // ----- small utilities -----
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function moneyShort(n) { return '$' + Math.round(n); }

  // ----- results: render from backend recommendation (fallback to static) -----
  function applyRecommendation() {
    var isTray = state.product === 'tray';
    // The response carries BOTH products; read the block for whichever product
    // is being shown. The alt-product toggle just flips state.product and
    // re-renders from the other block — no extra API call.
    var rec = (state.recommendation && state.recommendation[state.product])
      ? state.recommendation[state.product] : null;

    state.bundleProductId = (rec && rec.bundleProductId) || (isTray ? RECHARGE.trayProductId : RECHARGE.boxProductId);

    var productName = isTray ? 'Gourmet Bites Trays' : 'Curated Charcuterie Box';
    var themeName = (rec && rec.theme && !isTray) ? rec.theme.name : null;
    state.displayName = themeName ? themeName + ' Box' : productName;

    setText('fyp-results-tag-text', 'Your Recommendation: ' + state.displayName);
    setText('fyp-results-product-name', state.displayName);
    setText('fyp-match-product-label', (rec && rec.headline) ? rec.headline : (isTray ? 'Gourmet Bites Trays are your fit.' : 'Curated Charcuterie Box is your fit.'));

    renderGallery(isTray);

    var reasons = (rec && rec.reasons && rec.reasons.length) ? rec.reasons : (isTray
      ? ['You want something ready to eat the moment it arrives', 'Zero prep, zero cleanup - just open and enjoy', 'Perfect for solo snacking, desk lunches, or a quick indulgence', 'Each tray is built around a themed flavor story']
      : ['You want artisan quality that the grocery store cannot offer', 'You love discovering new, expertly paired flavors', 'You want enough to share (or savor over a few days)', 'You are ready for a board that looks like you know what you are doing']);
    var ul = byId('fyp-match-reasons-list');
    if (ul) ul.innerHTML = reasons.map(function (r) { return '<li>' + esc(r) + '</li>'; }).join('') + '<li>Fully customizable after checkout</li>';

    // Size / count selector at the top of the offer column (PDP-style, R-01/R-02/T-01).
    setText('fyp-size-label', isTray ? 'Choose your tray count' : 'Choose your box size');
    var boxSizesEl = byId('fyp-box-sizes'); if (boxSizesEl) boxSizesEl.style.display = isTray ? 'none' : 'flex';
    var traySizesEl = byId('fyp-tray-sizes'); if (traySizesEl) traySizesEl.style.display = isTray ? 'flex' : 'none';
    showEl('fyp-box-only-content', !isTray);
    showEl('fyp-tray-only-content', isTray);
    // No-pork can only be honored as a fully meat-free box (Q-03/R-11).
    showEl('fyp-nopork-note', state.answers.dietary === 'no_pork');

    // Frequencies + both size options come from the recommendation, else the
    // client fallback. The customer can switch size with NO extra API call.
    var fb = FALLBACK[state.product] || FALLBACK.box;
    state.freqs = (rec && rec.frequencies && rec.frequencies.length) ? rec.frequencies : fb.freqs;
    var selectedFreq = state.freqs.filter(function (f) { return f.popular; })[0] || state.freqs[0];
    state.selectedSellingPlan = selectedFreq ? selectedFreq.sellingPlanId : null;

    state.options = (rec && rec.options && rec.options.length) ? rec.options : fb.options;
    var defaultKey = (rec && rec.defaultOptionKey) ? rec.defaultOptionKey : fb.defaultOptionKey;
    renderSizeOptions(isTray, state.options, defaultKey);
    applyOption(findOption(defaultKey));
    renderWindow(isTray); // delivery-window list depends on product, not size

    // Box: show the free-pairing offer. Tray: no offer banner — the
    // no-commitment note lives at the bottom already (R-04).
    showEl('fyp-offer-banner', !isTray);
    if (!isTray) setText('fyp-offer-banner-text', 'OFFER APPLIED: FREE Artisan Cheese & Jam Pairing in Every Box For Life');

    var altBtn = byId('fyp-alt-product-btn');
    if (altBtn) altBtn.textContent = isTray ? 'Actually, show me the full Charcuterie Box' : 'Prefer ready-to-eat Gourmet Bites?';
  }

  function findOption(key) {
    var opts = state.options || [];
    return opts.filter(function (o) { return o.key === key; })[0] || opts[0] || null;
  }

  // Apply a selected size/count option — items, heading, tier prices, summary,
  // and the active checkout variant. Pure client-side, no API call.
  function applyOption(opt) {
    if (!opt) return;
    var isTray = state.product === 'tray';
    state.selectedOption = opt;
    state.checkout = { variantId: opt.variantId, sku: opt.sku, defaultSellingPlanId: opt.defaultSellingPlanId, items: opt.items || [] };

    if (opt.items && opt.items.length) {
      renderItems(isTray ? 'fyp-tray-items-grid' : 'fyp-box-items-grid', opt.items);
    }
    if (!isTray) {
      var themeName = state.displayName.replace(/ Box$/, '');
      setText('fyp-box-heading', themeName + ' — ' + opt.itemCount + ' items');
    }
    renderFreq(state.freqs, state.selectedSellingPlan);
    markSizeActive(opt.key);
    updateSummary();
  }

  function markSizeActive(key) {
    $all('[data-option-key]').forEach(function (el) {
      el.classList.toggle('fyp-plain', el.getAttribute('data-option-key') !== key);
    });
  }

  function updateSummary() {
    var opt = state.selectedOption;
    if (!opt) return;
    var freqs = state.freqs || [];
    var freq = freqs.filter(function (f) { return f.sellingPlanId === state.selectedSellingPlan; })[0]
      || freqs.filter(function (f) { return f.popular; })[0] || freqs[0];
    // Discount is excluded on the 6-tray (Medium tray) option only (R-06).
    var isMediumTray = state.product === 'tray' && opt.key === '6';
    var hasDiscount = cfg.discountAmount > 0 && cfg.discountCode && !isMediumTray;
    var today = hasDiscount ? Math.max(0, opt.basePrice - cfg.discountAmount) : opt.basePrice;
    setText('fyp-summary-product-name', state.displayName + ' · ' + opt.label + (freq ? ' (' + freq.label + ')' : ''));
    setText('fyp-summary-base-price', money(opt.basePrice));
    setText('fyp-summary-today-price', money(today));
    setText('fyp-sticky-product', state.displayName);
    setText('fyp-sticky-price', money(today));
    var discRow = byId('fyp-summary-discount-row');
    if (discRow) discRow.style.display = hasDiscount ? '' : 'none';
    if (hasDiscount) {
      setText('fyp-summary-discount-label', '🎉 Promo (CODE: ' + cfg.discountCode + ')');
      setText('fyp-summary-discount-amount', '-' + money(cfg.discountAmount));
    }
  }

  function renderSizeOptions(isTray, options, selectedKey) {
    var wrap = byId(isTray ? 'fyp-tray-sizes' : 'fyp-box-sizes');
    if (!wrap) return;
    var unit = isTray ? ' per shipment' : '/box';
    wrap.innerHTML = options.map(function (o) {
      var plain = o.key === selectedKey ? '' : ' fyp-plain';
      return '<div class="fyp-tray-count-opt' + plain + '" data-option-key="' + esc(o.key) + '">'
        + '<div class="fyp-tc-num">' + esc(o.label) + '</div>'
        + '<div class="fyp-tc-price"><span>' + moneyShort(o.basePrice) + unit + '</span><span class="fyp-tc-sep"> · </span><span>' + o.itemCount + ' items</span></div></div>';
    }).join('');
  }

  // ----- product image gallery (PDP-style: main image + thumbnails) -----
  var GALLERY = (function () {
    var el = byId('fyp-gallery-data');
    if (!el) return { box: [], tray: [] };
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return { box: [], tray: [] }; }
  })();
  // Delivery windows per product — the same custom_shipping_dates metaobjects
  // each PDP renders (box and tray lists differ; JS filters + switches them).
  var WINDOWS = (function () {
    var el = byId('fyp-window-data');
    if (!el) return { box: [], tray: [] };
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return { box: [], tray: [] }; }
  })();
  var galleryList = [];   // images for the currently shown product
  var galleryIndex = 0;

  function renderGallery(isTray) {
    galleryList = (isTray ? GALLERY.tray : GALLERY.box) || [];
    galleryIndex = 0;
    var mainImg = byId('fyp-results-product-img');
    var thumbs = byId('fyp-gallery-thumbs');
    // No gallery data (handle unresolved) → fall back to the single data-img-* image.
    if (!galleryList.length) {
      if (mainImg) {
        var fb = isTray ? mainImg.getAttribute('data-img-tray') : mainImg.getAttribute('data-img-box');
        if (fb) mainImg.src = fb;
      }
      if (thumbs) thumbs.innerHTML = '';
      return;
    }
    if (mainImg) { mainImg.src = galleryList[0].full; mainImg.alt = galleryList[0].alt || ''; }
    // Preload every full-size image so clicking a thumbnail swaps instantly
    // (otherwise the first click on each waits on a network fetch).
    galleryList.forEach(function (im) { var pre = new Image(); pre.src = im.full; });
    if (thumbs) {
      thumbs.innerHTML = galleryList.map(function (im, i) {
        return '<button type="button" class="fyp-gallery-thumb' + (i === 0 ? ' is-active' : '')
          + '" data-gallery-index="' + i + '" aria-label="View image ' + (i + 1) + '">'
          + '<img src="' + esc(im.thumb) + '" alt="' + esc(im.alt || '') + '"></button>';
      }).join('');
    }
  }

  function selectGalleryImage(index) {
    var n = galleryList.length;
    if (!n) return;
    // Wrap around so swiping past either end loops (last → first, first → last).
    index = ((index % n) + n) % n;
    galleryIndex = index;
    var im = galleryList[index];
    var mainImg = byId('fyp-results-product-img');
    if (mainImg) { mainImg.src = im.full; mainImg.alt = im.alt || ''; }
    $all('#fyp-gallery-thumbs .fyp-gallery-thumb').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-gallery-index') === String(index));
    });
  }

  // Full-screen image viewer (like the PDP's PhotoSwipe lightbox): counter,
  // prev/next, swipe, loop, Esc/backdrop to close. Built self-contained so it
  // doesn't pull the theme's Swiper/PhotoSwipe into the funnel.
  function openGalleryLightbox(startIndex) {
    if (!galleryList.length) return;
    var idx = startIndex;

    var overlay = document.createElement('div');
    overlay.className = 'fyp-lb-overlay';
    overlay.innerHTML =
      '<button type="button" class="fyp-lb-close" aria-label="Close">&times;</button>' +
      '<div class="fyp-lb-count"></div>' +
      '<button type="button" class="fyp-lb-nav fyp-lb-prev" aria-label="Previous image">&lsaquo;</button>' +
      '<img class="fyp-lb-img" src="" alt="">' +
      '<button type="button" class="fyp-lb-nav fyp-lb-next" aria-label="Next image">&rsaquo;</button>';
    document.body.appendChild(overlay);
    document.body.classList.add('fyp-lb-open');

    var imgEl = overlay.querySelector('.fyp-lb-img');
    var countEl = overlay.querySelector('.fyp-lb-count');
    var single = galleryList.length < 2;
    if (single) {
      overlay.querySelector('.fyp-lb-prev').style.display = 'none';
      overlay.querySelector('.fyp-lb-next').style.display = 'none';
    }

    function show(i) {
      var n = galleryList.length;
      idx = ((i % n) + n) % n;                 // wrap/loop
      var im = galleryList[idx];
      imgEl.src = im.full;
      imgEl.alt = im.alt || '';
      countEl.textContent = (idx + 1) + ' / ' + n;
      selectGalleryImage(idx);                 // keep the on-page gallery in sync
    }
    show(idx);

    function close() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.classList.remove('fyp-lb-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    }
    document.addEventListener('keydown', onKey);

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('.fyp-lb-close')) return close();
      if (e.target.closest('.fyp-lb-next')) return show(idx + 1);
      if (e.target.closest('.fyp-lb-prev')) return show(idx - 1);
      if (e.target === overlay) return close();   // tap backdrop to close
    });

    var sx = 0, sy = 0;
    overlay.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
  }

  // Swipe the main image left/right to move between gallery images.
  (function initGallerySwipe() {
    var main = byId('fyp-gallery-main');
    if (!main) return;
    var startX = 0, startY = 0;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!galleryList.length) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        selectGalleryImage(dx < 0 ? galleryIndex + 1 : galleryIndex - 1);
      }
    }, { passive: true });
  })();

  // Items last rendered per grid, so the info modal can look them up by index
  // without stuffing HTML/quotes into data attributes.
  var renderedItems = {};

  function renderItems(gridId, items) {
    var grid = byId(gridId);
    if (!grid) return;
    renderedItems[gridId] = items;
    grid.innerHTML = items.map(function (it, idx) {
      var img = it.imageUrl ? '<img src="' + esc(it.imageUrl) + '" alt="' + esc(it.title) + '">' : '';
      var hasInfo = it.description || it.ingredients;
      var info = hasInfo
        ? '<button type="button" class="fyp-item-info-btn" data-fyp-item-info="' + idx + '" data-fyp-grid="' + esc(gridId) + '" aria-label="More about ' + esc(it.title) + '"><span aria-hidden="true">i</span></button>'
        : '';
      return '<div class="fyp-witb-r-item">' + img + info + '<p>' + esc(it.title) + '</p></div>';
    }).join('');
  }

  // Delivery-frequency pill + dropdown (PDP under-button style). Builds the
  // option list and syncs the pill label to the current plan.
  function renderFreq(freqs, selectedPlanId) {
    var menu = byId('fyp-freq-menu');
    if (!menu) return;
    var selected = freqs.filter(function (f) { return f.sellingPlanId === selectedPlanId; })[0]
      || freqs.filter(function (f) { return f.popular; })[0] || freqs[0];
    if (selected) setText('fyp-freq-label', 'Delivery ' + selected.label);
    menu.innerHTML = freqs.map(function (f) {
      var active = (selected && f.sellingPlanId === selected.sellingPlanId) ? ' is-active' : '';
      return '<button type="button" class="fyp-freq-option' + active + '" role="option"'
        + ' data-selling-plan="' + esc(f.sellingPlanId) + '" data-label="' + esc(f.label) + '">'
        + esc(f.label) + '</button>';
    }).join('');
  }

  // ----- checkout: add variant + selling plan, apply discount, go to checkout -----
  var checkoutInFlight = false;

  // Default first-delivery rule — replicates the PDP (product-form-v2_2.js),
  // headless (no calendar UI):
  //  - generateDeliveryOptions(12): weekly Wed–Fri windows, ship the Monday
  //    (Wed − 2 days); Tuesday rolls to next week.
  //  - Ship-week shift ("rush default"): during the configured rush window the
  //    BOX pre-selects the SECOND window instead of the soonest. Trays opt out
  //    (Gourmet Bites — Friday cutoffs), so they always take the soonest.
  // Sends the same { 'First Delivery Window', '_SHIP', '_NEXT_BILLING_DATE' }
  // line-item properties the PDP sends, so orders schedule identically.
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var RUSH_DAY = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };

  function fmtYMD(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function fmtRangePdp(s, e) {
    return s.getMonth() === e.getMonth()
      ? MONTHS[s.getMonth()] + ' ' + s.getDate() + '-' + e.getDate()
      : MONTHS[s.getMonth()] + ' ' + s.getDate() + '-' + MONTHS[e.getMonth()] + ' ' + e.getDate();
  }
  function generateDeliveryOptions(weeks) {
    var options = [];
    var cur = new Date();
    var daysUntilWed = (3 - cur.getDay() + 7) % 7;
    if (cur.getDay() === 2) daysUntilWed += 7; // Tuesday → next week
    cur.setDate(cur.getDate() + daysUntilWed);
    for (var w = 0; w < weeks; w++) {
      var start = new Date(cur);
      var end = new Date(cur); end.setDate(end.getDate() + 2); // Friday
      var ship = new Date(start); ship.setDate(ship.getDate() - 2); // Monday
      options.push({
        label: fmtRangePdp(start, end),
        value: start.toISOString().split('T')[0],
        ship: ship.toISOString().split('T')[0]
      });
      cur.setDate(cur.getDate() + 7);
    }
    return options;
  }

  // Rush ship-week shift, from the shop metafield rendered as a script tag.
  function rushConfig() {
    var el = document.querySelector('script[data-rush-default-window-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  }
  function minuteOfWeek(date, tz) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, weekday: 'long', hour: '2-digit', minute: '2-digit' })
      .formatToParts(date).reduce(function (a, p) { a[p.type] = p.value; return a; }, {});
    var dow = RUSH_DAY[parts.weekday.toLowerCase()];
    return dow * 1440 + (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10);
  }
  function mowFromConfig(day, hhmm) {
    var p = hhmm.split(':').map(Number);
    return RUSH_DAY[day.toLowerCase()] * 1440 + p[0] * 60 + p[1];
  }
  function shouldSkipSoonest() {
    var cfg = rushConfig();
    if (!cfg || !cfg.enabled) return false;
    var now = minuteOfWeek(new Date(), cfg.timezone || 'America/New_York');
    var s = mowFromConfig(cfg.starts.day, cfg.starts.time);
    var e = mowFromConfig(cfg.ends.day, cfg.ends.time);
    return s <= e ? (now >= s && now <= e) : (now >= s || now <= e);
  }

  function nextBillingDate(shipStr, freqLabel) {
    var today = new Date();
    var date = new Date(shipStr + 'T00:00:00');
    var min = new Date(today); min.setDate(today.getDate() + 7);
    if (date < min) return null;
    var m = (freqLabel || '').match(/every (\d+) (month|weeks)/i);
    if (!m) return shipStr;
    if (m[2].toLowerCase() === 'month') date.setMonth(date.getMonth() + parseInt(m[1], 10));
    else date.setDate(date.getDate() + parseInt(m[1], 10) * 7);
    return fmtYMD(date);
  }
  function defaultDeliveryProps(product, freqLabel) {
    var options = generateDeliveryOptions(12);
    if (!options.length) return {};
    // Box honors the rush ship-week shift; trays opt out (always soonest).
    var idx = (product === 'box' && options.length >= 2 && shouldSkipSoonest()) ? 1 : 0;
    var chosen = options[idx];
    var props = { 'First Delivery Window': chosen.label, '_SHIP': chosen.ship };
    var nbd = nextBillingDate(chosen.ship, freqLabel);
    if (nbd) props['_NEXT_BILLING_DATE'] = nbd;
    return props;
  }
  // Label of the currently selected delivery frequency (for next-billing calc).
  function selectedFreqLabel(plan) {
    var f = (state.freqs || []).filter(function (x) { return x.sellingPlanId === plan; })[0];
    return f ? f.label : '';
  }

  // ----- delivery-window picker (mirrors each PDP's custom shipping dates) -----
  function fmtWin(startYMD, endYMD) {
    var s = new Date(startYMD + 'T00:00:00');
    var e = new Date(endYMD + 'T00:00:00');
    return s.getMonth() === e.getMonth()
      ? MONTHS[s.getMonth()] + ' ' + s.getDate() + ' - ' + e.getDate()
      : MONTHS[s.getMonth()] + ' ' + s.getDate() + ' - ' + MONTHS[e.getMonth()] + ' ' + e.getDate();
  }
  // Same visibility rule as the PDP: keep a window while its cutoff
  // (shipping_date_expires, else shipping_date + 1 day) is still in the future.
  function windowValid(w) {
    var nowSec = Math.floor(new Date().getTime() / 1000);
    var cutoff = w.expires
      ? parseInt(w.expires, 10)
      : (Math.floor(new Date(w.ship + 'T00:00:00').getTime() / 1000) + 86400);
    return cutoff >= nowSec;
  }
  // Inline flatpickr range calendar — same config as the PDP date-picker:
  // enabled dates = the delivery windows; clicking any day snaps to the whole
  // window; box honors the rush ship-week shift, trays take the soonest.
  var fpInstance = null;
  function renderWindow(isTray) {
    var block = byId('fyp-window-block');
    if (!block) return;
    var all = (WINDOWS[isTray ? 'tray' : 'box'] || []).filter(windowValid);
    if (!all.length) { block.style.display = 'none'; state.selectedWindow = null; return; }
    block.style.display = '';
    var ranges = all.map(function (w) {
      return { from: new Date(w.start + 'T00:00:00'), to: new Date(w.end + 'T23:59:59'), ship: w.ship, label: fmtWin(w.start, w.end) };
    });
    var def = ranges[(!isTray && ranges.length >= 2 && shouldSkipSoonest()) ? 1 : 0];
    state.selectedWindow = { label: def.label, ship: def.ship };
    setText('fyp-window-value', def.label);

    if (typeof flatpickr === 'undefined') return; // lib not loaded → keep default
    var input = byId('fyp-delivery-date-input');
    var container = byId('fyp-calendar-container');
    if (!input || !container) return;
    if (fpInstance) { fpInstance.destroy(); fpInstance = null; }
    fpInstance = flatpickr(input, {
      mode: 'range',
      dateFormat: 'F j, Y',
      appendTo: container,
      static: true,
      inline: true,
      minDate: ranges[0].from,
      maxDate: new Date(ranges[ranges.length - 1].to.getTime() + 86400000),
      firstDayOfWeek: 0,
      enable: [function (date) { return ranges.some(function (r) { return date >= r.from && date <= r.to; }); }],
      defaultDate: [new Date(def.from), new Date(def.to)],
      onChange: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          var d = selectedDates[0];
          var m = ranges.filter(function (r) { return d >= r.from && d <= r.to; })[0];
          if (m) instance.setDate([m.from, m.to], true); else instance.clear();
        } else if (selectedDates.length === 2) {
          var m2 = ranges.filter(function (r) { return selectedDates[0] >= r.from && selectedDates[1] <= r.to; })[0];
          if (!m2) { instance.clear(); return; }
          state.selectedWindow = { label: m2.label, ship: m2.ship };
          setText('fyp-window-value', m2.label);
          closeWindow();
        }
        window.setTimeout(function () { attachRangeHover(fpInstance, ranges); }, 0);
      },
      onMonthChange: function () { window.setTimeout(function () { attachRangeHover(fpInstance, ranges); }, 0); },
      onReady: function () { window.setTimeout(function () { attachRangeHover(fpInstance, ranges); }, 0); }
    });
  }

  // Whole-window hover preview (mirrors the PDP calendar interaction).
  function attachRangeHover(fp, ranges) {
    if (!fp || !fp.calendarContainer) return;
    var days = fp.calendarContainer.getElementsByClassName('flatpickr-day');
    function clearHover() {
      Array.prototype.forEach.call(days, function (el) {
        el.classList.remove('hover-in-range', 'hover-startRange', 'hover-endRange');
      });
    }
    Array.prototype.forEach.call(days, function (day) {
      day.onmouseover = function () {
        clearHover();
        if (day.classList.contains('flatpickr-disabled')) return;
        var date = new Date(day.dateObj);
        var r = ranges.filter(function (x) { return date >= x.from && date <= x.to; })[0];
        if (!r) return;
        Array.prototype.forEach.call(days, function (el) {
          if (el.classList.contains('flatpickr-disabled') || el.classList.contains('selected')
            || el.classList.contains('startRange') || el.classList.contains('endRange') || el.classList.contains('inRange')) return;
          var ed = new Date(el.dateObj);
          if (ed.toDateString() === r.from.toDateString()) el.classList.add('hover-startRange');
          else if (ed.toDateString() === r.to.toDateString()) el.classList.add('hover-endRange');
          else if (ed > r.from && ed < r.to) el.classList.add('hover-in-range');
        });
      };
    });
    fp.calendarContainer.onmouseleave = clearHover;
  }
  function toggleWindow() {
    var w = byId('fyp-window');
    if (!w) return;
    var open = w.classList.toggle('is-open');
    var f = w.querySelector('.fyp-window-field');
    if (f) f.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeWindow() {
    var w = byId('fyp-window');
    if (!w) return;
    w.classList.remove('is-open');
    var f = w.querySelector('.fyp-window-field');
    if (f) f.setAttribute('aria-expanded', 'false');
  }
  // First-delivery line-item props from the chosen window (falls back to the
  // headless PDP default rule if no window is available for this product).
  function windowDeliveryProps(freqLabel) {
    var w = state.selectedWindow;
    if (!w) return defaultDeliveryProps(state.product, freqLabel);
    var props = { 'First Delivery Window': w.label, '_SHIP': w.ship };
    var nbd = nextBillingDate(w.ship, freqLabel);
    if (nbd) props['_NEXT_BILLING_DATE'] = nbd;
    return props;
  }

  // Lazily initialize the Recharge SDK once (script is loaded in the section).
  var rechargeReady = false;
  function initRecharge() {
    if (rechargeReady) return true;
    if (!window.recharge || !window.recharge.init || !window.recharge.bundle) return false;
    try {
      window.recharge.init({ storeIdentifier: RECHARGE.storeIdentifier, appName: 'find-your-pairing', appVersion: '1.0.0' });
      rechargeReady = true;
    } catch (e) { if (window.console) console.warn('[find-your-pairing] recharge.init failed', e); }
    return rechargeReady;
  }

  function redirectToCheckout() {
    var code = cfg.discountCode;
    // /discount/{code}?redirect=/checkout applies the code, then goes to checkout.
    window.location.href = code
      ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout'
      : '/checkout';
  }

  // POST cart/clear then cart/add(items), then redirect. Shared by both paths.
  function clearAddRedirect(items, c, plan, btn, original) {
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/clear ' + r.status);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); })
      .then(function () { redirectToCheckout(); })
      .catch(function (err) {
        if (window.console && console.error) console.error('[find-your-pairing] checkout failed', err);
        checkoutInFlight = false;
        if (btn) { btn.textContent = original; btn.style.opacity = ''; }
        // Last resort: cart permalink (builds a fresh cart with the bundle variant).
        var plink = '/cart/' + encodeURIComponent(c.variantId) + ':1' + (plan ? '?selling_plan=' + encodeURIComponent(plan) : '');
        window.location.href = plink;
      });
  }

  // The FREE Artisan Cheese & Jam Pairing line ($0 gift product) — box only,
  // added as a child of the box line, same as the customize-my-box flow.
  // Returns [] when not applicable so it can be safely concatenated.
  function freeGiftLines(c) {
    if (state.product !== 'box' || !cfg.freeGiftVariantId) return [];
    return [{ id: Number(cfg.freeGiftVariantId), quantity: 1, parent_id: Number(c.variantId) }];
  }

  // Add only the bundle variant (no itemized children). Used when items/IDs are
  // unavailable or the Recharge bundle step fails — the subscription still works.
  function addBareAndCheckout(c, plan, deliveryProps, btn, original) {
    var item = { id: Number(c.variantId), quantity: 1 };
    if (plan) item.selling_plan = Number(plan);
    if (deliveryProps && Object.keys(deliveryProps).length) item.properties = deliveryProps;
    return clearAddRedirect([item].concat(freeGiftLines(c)), c, plan, btn, original);
  }

  function startCheckout(btn) {
    if (checkoutInFlight) return;
    var c = state.checkout;
    if (!c || !c.variantId) {
      // Total-outage fallback: default option from the client table.
      var fb = FALLBACK[state.product] || FALLBACK.box;
      c = fb.options.filter(function (o) { return o.key === fb.defaultOptionKey; })[0] || fb.options[0];
    }
    if (!c || !c.variantId) { window.location.href = '/cart'; return; }

    var plan = state.selectedSellingPlan || c.defaultSellingPlanId || null;

    // First-delivery schedule from the "Choose a delivery window" picker,
    // applied to the box line so the order schedules like the PDP.
    var deliveryProps = windowDeliveryProps(selectedFreqLabel(plan));

    // Build Recharge bundle "selections" from the chosen items. Each needs the
    // collection/product/variant IDs the backend now returns.
    var selections = (c.items || [])
      .filter(function (it) { return it && it.variantId && it.productId && it.collectionId; })
      .map(function (it) {
        return {
          collectionId: Number(it.collectionId),
          externalProductId: Number(it.productId),
          externalVariantId: Number(it.variantId),
          quantity: 1
        };
      });

    track('checkout_click', { product: state.product, variantId: c.variantId, sellingPlan: plan, sku: c.sku, itemCount: selections.length });

    checkoutInFlight = true;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding to cart…'; btn.style.opacity = '0.7'; }

    // No resolvable items, no selling plan, or SDK not ready → bare bundle.
    if (!selections.length || !plan || !initRecharge()) {
      return addBareAndCheckout(c, plan, deliveryProps, btn, original);
    }

    // Provision the bundle via Recharge, then add the single box line tagged
    // with _rb_id (+ the free-gift line) — exactly like the customize-my-box flow.
    var bundle = {
      externalVariantId: Number(c.variantId),
      externalProductId: Number(state.bundleProductId),
      selections: selections
    };

    Promise.resolve(window.recharge.bundle.getBundleId(bundle))
      .then(function (rbId) {
        if (!rbId) throw new Error('no rbId');
        // ONE line item: the box variant (which carries the price). The chosen
        // items are NOT added as separate cart lines — they'd each charge their
        // own price on top of the box. Instead they're registered server-side
        // via getBundleId (the `selections` above) and referenced by _rb_id, and
        // listed for display in the "Box Contents" property — same as the
        // customize-my-box checkout.
        var contents = (c.items || []).map(function (it) { return '1x ' + it.title; }).join(', ');
        var boxLine = {
          id: Number(c.variantId),
          quantity: 1,
          selling_plan: Number(plan),
          properties: Object.assign({ '_rb_id': rbId, 'Box Contents': contents }, deliveryProps)
        };
        return clearAddRedirect([boxLine].concat(freeGiftLines(c)), c, plan, btn, original);
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[find-your-pairing] bundle step failed, adding bare bundle', err);
        addBareAndCheckout(c, plan, deliveryProps, btn, original);
      });
  }

  function selectFreq(optionEl) {
    $all('.fyp-freq-option').forEach(function (o) { o.classList.remove('is-active'); });
    optionEl.classList.add('is-active');
    var plan = optionEl.getAttribute('data-selling-plan');
    if (plan) state.selectedSellingPlan = plan;
    setText('fyp-freq-label', 'Delivery ' + (optionEl.getAttribute('data-label') || ''));
    closeFreq();
    updateSummary();
  }

  function toggleFreq() {
    var f = byId('fyp-freq');
    if (!f) return;
    var open = f.classList.toggle('is-open');
    var tgl = f.querySelector('.fyp-freq-toggle');
    if (tgl) tgl.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeFreq() {
    var f = byId('fyp-freq');
    if (!f) return;
    f.classList.remove('is-open');
    var tgl = f.querySelector('.fyp-freq-toggle');
    if (tgl) tgl.setAttribute('aria-expanded', 'false');
  }

  function toggleFaq(btn) {
    var answer = btn.nextElementSibling;
    var icon = $('.fyp-faq-icon', btn);
    var isOpen = answer && answer.classList.contains('is-open');
    $all('.fyp-faq-a').forEach(function (a) { a.classList.remove('is-open'); });
    $all('.fyp-faq-icon').forEach(function (i) { i.textContent = '+'; });
    if (!isOpen && answer) { answer.classList.add('is-open'); if (icon) icon.textContent = '−'; }
  }

  // ----- countdown -----
  var countdownInterval = null;
  function startCountdown() {
    var el = byId('fyp-countdown');
    if (!el) return;
    if (countdownInterval) window.clearInterval(countdownInterval);
    var total = cfg.countdownSeconds;
    countdownInterval = window.setInterval(function () {
      if (total <= 0) { window.clearInterval(countdownInterval); return; }
      total--;
      var m = Math.floor(total / 60), s = total % 60;
      el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }, 1000);
  }

  // ----- event delegation -----
  root.addEventListener('click', function (e) {
    var t = e.target;

    var goQuiz = t.closest('[data-fyp-action="go-quiz"]');
    if (goQuiz) { e.preventDefault(); goToQuiz(goQuiz.getAttribute('data-fyp-entry-product')); return; }

    var goHome = t.closest('[data-fyp-action="go-home"]');
    if (goHome) { e.preventDefault(); showView('home'); return; }

    var galThumb = t.closest('[data-gallery-index]');
    if (galThumb) { e.preventDefault(); selectGalleryImage(parseInt(galThumb.getAttribute('data-gallery-index'), 10)); return; }

    var galMain = t.closest('#fyp-gallery-main');
    if (galMain && galleryList.length) { e.preventDefault(); openGalleryLightbox(galleryIndex); return; }

    // Per-item info modal (the "ⓘ" on each result card). Reuses the shared
    // ProductInfoPopup so it matches the customize-my-box flow exactly.
    var infoBtn = t.closest('[data-fyp-item-info]');
    if (infoBtn) {
      e.preventDefault();
      var gid = infoBtn.getAttribute('data-fyp-grid');
      var idx = parseInt(infoBtn.getAttribute('data-fyp-item-info'), 10);
      var item = (renderedItems[gid] || [])[idx];
      if (item && window.ProductInfoPopup) {
        // Product body holds the copy (matches customize-my-box, which hides the
        // metafield block); fall back to the metafield only if the body is empty.
        window.ProductInfoPopup.open({
          title: item.title,
          imageUrl: item.imageUrl,
          descriptionHtml: item.description || item.ingredients || '',
          ingredientsHtml: ''
        });
      }
      return;
    }

    var nextBtn = t.closest('[data-fyp-next]');
    if (nextBtn) {
      e.preventDefault();
      recordAnswer(nextBtn);
      var nextId = nextBtn.getAttribute('data-fyp-next');
      // Product already known (product-specific entry) → skip Q5. Box → the
      // preferences step first; tray → straight to results.
      if (nextId === 'fyp-q5' && state.entryProduct) {
        nextBtn.closest('.fyp-quiz-card').style.display = 'none';
        if (state.entryProduct === 'box') routeBox('fyp-q4');
        else showLoadingThenResults(state.entryProduct);
        return;
      }
      gotoCard(nextBtn.closest('.fyp-quiz-card'), nextId);
      return;
    }

    var backBtn = t.closest('[data-fyp-back]');
    if (backBtn) {
      e.preventDefault();
      gotoCard(backBtn.closest('.fyp-quiz-card'), backBtn.getAttribute('data-fyp-back'));
      return;
    }

    // Gift branch (Q-06): show the in-page box catalog for the chosen gift type.
    var giftBtn = t.closest('[data-fyp-gift-dest]');
    if (giftBtn) {
      e.preventDefault();
      recordAnswer(giftBtn);
      var dest = giftBtn.getAttribute('data-fyp-gift-dest');
      track('gift_route', { giftType: dest });
      showGiftCatalog(dest);
      return;
    }

    var productBtn = t.closest('[data-fyp-product]');
    if (productBtn) {
      e.preventDefault();
      recordAnswer(productBtn);
      var prod = productBtn.getAttribute('data-fyp-product');
      // Box → the preferences step first; tray → straight to results.
      if (prod === 'box') routeBox('fyp-q5');
      else showLoadingThenResults(prod);
      return;
    }

    var prefsContinue = t.closest('[data-fyp-action="prefs-continue"]');
    if (prefsContinue) {
      e.preventDefault();
      var pin = byId('fyp-prefs-input');
      state.preferences = pin ? (pin.value || '').trim() : '';
      showLoadingThenResults('box');
      return;
    }
    var prefsSkip = t.closest('[data-fyp-action="prefs-skip"]');
    if (prefsSkip) {
      e.preventDefault();
      state.preferences = '';
      showLoadingThenResults('box');
      return;
    }

    var checkoutBtn = t.closest('[data-fyp-action="checkout"]');
    if (checkoutBtn) { e.preventDefault(); startCheckout(checkoutBtn); return; }

    var sizeOpt = t.closest('[data-option-key]');
    if (sizeOpt) {
      var opt = findOption(sizeOpt.getAttribute('data-option-key'));
      if (opt) applyOption(opt); // client-side only, no API call
      return;
    }

    var freqToggle = t.closest('[data-fyp-action="freq-toggle"]');
    if (freqToggle) { e.preventDefault(); toggleFreq(); return; }

    var freqOption = t.closest('.fyp-freq-option');
    if (freqOption) { e.preventDefault(); selectFreq(freqOption); return; }

    var winToggle = t.closest('[data-fyp-action="window-toggle"]');
    if (winToggle) { e.preventDefault(); toggleWindow(); return; }

    var faq = t.closest('[data-fyp-action="toggle-faq"]');
    if (faq) { e.preventDefault(); toggleFaq(faq); return; }

    var alt = t.closest('[data-fyp-action="alt-product"]');
    if (alt) {
      e.preventDefault();
      state.product = state.product === 'tray' ? 'box' : 'tray';
      applyRecommendation();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  });

  // Close the frequency pill / delivery-window dropdown on any click outside them.
  document.addEventListener('click', function (e) {
    var f = byId('fyp-freq');
    if (f && f.classList.contains('is-open') && !e.target.closest('#fyp-freq')) closeFreq();
    var w = byId('fyp-window');
    if (w && w.classList.contains('is-open') && !e.target.closest('#fyp-window')) closeWindow();
  });

  // ----- sticky mobile CTAs (home hero + results checkout) -----
  var homeSticky = byId('fyp-sticky-cta');
  var resultsSticky = byId('fyp-results-sticky-cta');
  function updateStickies() {
    var homeShow = false, resultsShow = false;
    if (homeSticky) {
      homeShow = $('[data-fyp-view="home"]').classList.contains('is-active') && window.scrollY > 500;
      homeSticky.style.display = homeShow ? 'block' : 'none';
    }
    if (resultsSticky) {
      var resultsActive = $('[data-fyp-view="results"]').classList.contains('is-active');
      var faq = $('[data-fyp-view="results"] .fyp-faq-wrap');
      // Appears once the "Questions we hear all the time" section scrolls into view.
      if (resultsActive && faq) {
        resultsShow = faq.getBoundingClientRect().top < window.innerHeight;
      }
      resultsSticky.classList.toggle('is-visible', resultsShow);
    }
    // Flag on <body> so global CSS lifts the chat / accessibility widgets above whichever bar shows.
    document.body.classList.toggle('fyp-sticky-visible', homeShow || resultsShow);
  }
  if (homeSticky || resultsSticky) {
    window.addEventListener('scroll', updateStickies, { passive: true });
    window.addEventListener('resize', updateStickies);
  }

  // ----- deep-link entry (ads / homepage hero) -----
  // ?product=tray|box  → start the quiz with the product pre-set (skips Q5).
  // ?quiz=1 (or start=quiz) → start the generic quiz (Q5 still asked).
  (function initFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      var p = (params.get('product') || '').toLowerCase();
      if (p === 'tray' || p === 'box') goToQuiz(p);
      else if (params.get('quiz') === '1' || params.get('start') === 'quiz') goToQuiz();
    } catch (e) {}
  })();
})();
